import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import { useIsMobile } from '../../hooks/useResponsive';

// A form dialog — create, edit, profile — that fills a phone's screen: a
// centred modal there leaves the form a narrow column between margins, and
// the keyboard covers what is left. Confirmations and other small dialogs
// stay modal on every screen and keep MUI's Dialog.
export default function FormDialog({ children, PaperProps, ...props }) {
    const fullScreen = useIsMobile();

    return (
        <Dialog
            fullScreen={fullScreen}
            PaperProps={{
                ...PaperProps,
                sx: [
                    fullScreen && { pb: 'env(safe-area-inset-bottom)' },
                    ...(Array.isArray(PaperProps?.sx)
                        ? PaperProps.sx
                        : [PaperProps?.sx])
                ]
            }}
            {...props}
        >
            {children}
        </Dialog>
    );
}

FormDialog.propTypes = {
    children: PropTypes.node,
    PaperProps: PropTypes.object
};
